<template>
  <div :class="$style.page">
    <Loading :loading="loading" :text="loadingText">
      <Title title="个人认证">
        <template v-slot:actions>
          <span :class="$style.goBack" @click="goBack">返回</span>
        </template>
      </Title>

      <Row>
        <Item title="姓名"><el-input v-model.trim="name" /></Item>
        <Button type="primary" size="small" @click="searchPerson(1)">
          搜索
        </Button>
        <Button type="blue" @click="setVisible(true)"> 添加个人认证 </Button>
      </Row>

      <Divider />

      <Title title="搜索结果" :count="total" />

      <!-- 搜索结果 -->
      <el-table
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="序号" width="30" align="center">
          <template slot-scope="scope">
            {{ limit * (page - 1) + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="username"
          label="姓名"
          width="80"
          align="center"
        />

        <el-table-column
          prop="cardType"
          label="证件类型"
          width="50"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.cardType === 0 ? "身份证" : "护照" }}
          </template>
        </el-table-column>

        <el-table-column
          prop="cardNum"
          label="证件号码"
          width="120"
          align="center"
        />

        <el-table-column
          prop="createdTime"
          label="提交时间"
          width="120"
          align="center"
        />

        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{ mapStatus[scope.row.status] }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isCer === 1">-</span>
            <span
              v-else
              :class="$style.action_btn"
              @click="deleteUser(scope.row.cardId)"
            >
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="loadMorePage"
      />
    </Loading>

    <!-- 实名认证弹窗 -->
    <RealNamePopup
      mode="popup"
      :visible="visible"
      @close="setVisible(false)"
      @success="searchPerson"
    />
  </div>
</template>

<script>
import RealNamePopup from "./certify/RealNamePopup.vue";

import { getCertifyUser, deleteCertifyUser } from "@server";

export default {
  name: "CertifyUser",
  components: {
    RealNamePopup,
  },
  data() {
    return {
      name: "",
      page: 1,
      limit: 10,
      showList: [],
      total: 0,

      loading: false,
      loadingText: "加载中...",
      visible: false,

      mapStatus: {
        0: "认证中",
        1: "认证成功",
        2: "认证失败",
      },
    };
  },
  created() {
    this.searchPerson();
  },
  methods: {
    async searchPerson(page = 1) {
      this.loadingText = "加载中...";
      this.loading = true;
      this.page = page;

      const params = {
        limit: this.limit,
        page,
      };
      this.name && (params.username = this.name);
      const res = await getCertifyUser(params);
      const { code, data } = res;

      if (code === 200) {
        this.showList = data.list;
        this.total = data.total;
      }

      this.loading = false;
    },

    async deleteUser(id) {
      this.$confirm("确定要删除这条个人认证吗？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loadingText = "删除中...";
          this.loading = true;

          const res = await deleteCertifyUser(id);
          if (res.code === 200) {
            this.$message({ message: "删除成功!", type: "success" });
            this.searchPerson();
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    loadMorePage(page) {
      this.searchPerson(page);
    },

    setVisible(v) {
      this.visible = v;
    },

    goBack() {
      this.$router.push("/user/certification");
    },
  }
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  padding-top: rem(10);
  background: $white;

  :global {
    .gl-title {
      margin-bottom: rem(20);
    }

    .gl-row {
      padding-bottom: rem(40);
    }

    .gl-item {
      margin-right: rem(30);
    }

    .el-input {
      width: rem(300);
    }

    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .action_btn {
    cursor: pointer;
    &:hover {
      color: $theme-color;
    }
  }

  .goBack {
    padding: 5px;
    font-size: rem(14);
    color: #333;
    cursor: pointer;
    &:hover {
      color: $theme-color;
    }
  }
}
</style>
